import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateSubjectDoctorLog(
    $id: String!
    $data: updateSubjectDoctorLogInput!
  ) {
    updateSubjectDoctorLog(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateSubjectDoctorLogRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateSubjectDoctorLogInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject_doctor_log/update_subject_doctor_log',
  async (
  params: {id: String;data: TYPES.UpdateSubjectDoctorLogInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateSubjectDoctorLog;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateSubjectDoctorLogSlice = createSlice({
  name: 'update_subject_doctor_log',
  initialState: initialState,
  reducers: {
    updateSubjectDoctorLogClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateSubjectDoctorLogRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateSubjectDoctorLogRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateSubjectDoctorLogRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateSubjectDoctorLogClear } =
updateSubjectDoctorLogSlice.actions;

export const updateSubjectDoctorLog = createSelector(
  (state: RootState) =>
  state.subjectDoctorLog.updateSubjectDoctorLog.result,
  (state: RootState) =>
  state.subjectDoctorLog.updateSubjectDoctorLog.error,
  (state: RootState) =>
  state.subjectDoctorLog.updateSubjectDoctorLog.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateSubjectDoctorLogSlice.reducer;